module.exports = __webpack_public_path__ + "fonts/SalesforceSans-Italic.882515c44aafee22611dbcbc904a792b.woff";